<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex, 'is-dialog': isDialog }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      @keyup.enter.native="submit"
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="email">
        <!-- 邮箱 -->
        <BaseInput
          v-model="form.email"
          :disabled="fromPlatform || fromGuest"
          :placeholer="$t('login.loginPage.enterYourEmail')"
        />
      </el-form-item>

      <el-form-item
        class="form-item-primary"
        prop="password"
        :class="{ 'higher-height': $i18n.locale === 'en' }"
      >
        <BaseInput
          v-model="form.password"
          type="password"
          :validate-event="Boolean(form.password)"
          :placeholer="$t('login.loginPage.passwords')"
        />
      </el-form-item>
      <el-form-item>
        <p class="forgot-password" @click="forgotPassword">
          {{ $t('login.loginPage.forgetPassword') }}
        </p>
      </el-form-item>
    </el-form>

    <el-button
      class="button-custom"
      @click="submit"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.signIn`,
      }"
      >{{ $t('login.loginPage.signIn') }}</el-button
    >
  </div>
</template>

<script>
import BaseInput from '@/components/common/BaseInput.vue'
import BaseMixin from '@/mixins/BaseMixin'
import LoginStepDetailMixin from '../mixins/LoginStepDetailMixin'
import { checkPassword } from '@/utils/validate-rules'
import handleSaveAndJump from '@/utils/saveLogin.js'
import store from '@/store'
import { checkPorscheEmail } from '../valid'
import { getBusinessType } from '@/constant'

export default {
  name: '',
  props: {},
  mixins: [BaseMixin, LoginStepDetailMixin],
  data() {
    return {
      form: {
        email: '',
      },
    }
  },

  components: { BaseInput },

  computed: {
    getEmail() {
      return this.$route.params.step
    },
    submitDisabled() {
      let _disabled = false
      ;[('email', 'password')].forEach((key) => {
        if (!this.form[key]) {
          _disabled = true
        }
      })
      return _disabled
    },
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t('login.register.inputEmail'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              if (checkPorscheEmail(value.toLowerCase())) {
                try {
                  let { data } = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data) {
                    return callback(
                      new Error(this.$t('login.register.notExists'))
                    )
                  } else {
                    return callback()
                  }
                } catch (error) {
                  return callback()
                }
              }
              return callback(
                new Error(this.$t('login.register.needCanUseEmail'))
              )
            },
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.email.register.setPassPop'),
          },
          {
            validator: (rule, value, callback) => {
              if (!checkPassword(value)) {
                callback(
                  new Error(this.$t('login.email.register.showPasswordRules'))
                )
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {},
  methods: {
    setAccount(value) {
      const result = checkPorscheEmail(value)
      if (result) {
        this.$store.commit('setCurrentAccount', value)
      }
    },
    initAccount(account) {
      // 如果参数中存在account且符合规则，则自动写入
      if (checkPorscheEmail(account)) {
        this.form.email = account
      } else {
        this.$router.replace({
          path: `/cim`,
          query: {
            ...this.$route.query,
          },
        })
      }
    },
    submit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.password = this.form.password
            .replace(/[\u4e00-\u9fa5]/gi, '')
            .replace(/\s+/g, '')

          const { email, password } = this.form
          let params = {
            user_name: email,
            password,
          }

          if (this.fromGuest) {
            params.gi_guest = this.gi_guest
          }

          if (getBusinessType().isNeedTagedSource) {
            params.source = getBusinessType().unionId
          }

          const data = await store.dispatch('userLogin', params, this.gi_guest)
          if (data.code === 0) {
            this.$message.success(this.$t('login.loginPage.success'))
            handleSaveAndJump(data.data)
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.login-btn-default {
  margin-top: 8px;
}
.form-custom {
  margin-top: 40px;
  margin-bottom: 40px;
}
.form-custom.is-dialog {
  margin-top: 0;
  margin-bottom: 12px;
}
.forgot-password {
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  float: right;
  color: #f0386c;
  text-align: right;
  cursor: pointer;
}
</style>
